<div class="form-wizard-stepper">
    <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
</div>